import { render } from "./AdicionarCartaoCorretor.vue?vue&type=template&id=28b70fa6&scoped=true"
import script from "./AdicionarCartaoCorretor.vue?vue&type=script&lang=js"
export * from "./AdicionarCartaoCorretor.vue?vue&type=script&lang=js"

import "./AdicionarCartaoCorretor.vue?vue&type=style&index=0&id=28b70fa6&scoped=true&lang=css"

import exportComponent from "I:\\Centrion\\projetos\\aut_fri_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28b70fa6"]])

export default __exports__